const formatSeconds = (value?: number) => {
    if (value === undefined || value === null) return "-";
    const minutes = Math.floor(value / 60);
    const seconds = Math.floor(value % 60);
    return minutes > 0
        ? `${minutes}m ${seconds}s`
        : `${seconds}s`;
};

export { formatSeconds }